import React from 'react'
import Cryoprep from './Cryoprep'
// import { IconAlternate } from 'components/molecules';


export const services = [
    {
      icon: 'fas fa-layer-group',
      title: 'Increases yields with an integrated and rapid workflow ',

    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'Preserves stable and labile molecules ',

    },
    {
      icon: 'fas fa-dna',
      title: 'Maintains samples at cryogenic temperatures ',

    },
    {
      icon: 'fas fa-layer-group',
      title: 'Eliminates clean-up and risk of contamination with single-use tissueTUBE  ',

    },
  ];

function Cryopreppart() {
    return (
        <div>
           <Cryoprep data = {services}/> 
        </div>
    )
}

export default Cryopreppart
